import React, { useState } from 'react';
import PageHero from '../components/PageHero';
import { Helmet } from "react-helmet-async";
import CTASection from '../components/CTASection';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import contact from '../assets/Hero/contactus.svg'

const { FiMapPin, FiPhone, FiMail, FiClock } = FiIcons;

export default function Contact() {

  // ✅ Detect react-snap prerender
  const isPrerender = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "917013686917";

    const text = `
Name: ${formData.name}
Phone: ${formData.phone}
Email: ${formData.email}
Message: ${formData.message}
    `;

    const encodedText = encodeURIComponent(text);
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedText}`;

    window.open(whatsappURL, "_blank");

    setFormData({ name: '', phone: '', email: '', message: '' });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div>

      <Helmet>
        <title>Contact Dental Sleep Care | Sleep Apnea & TMJ Clinic in Hyderabad</title>

        <meta
          name="description"
          content="Contact Dental Sleep Care in Hyderabad for sleep apnea, TMJ treatment, and airway-focused dental care. Book your consultation today."
        />

        {/* ✅ Local Business Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Dentist",
            "name": "Dental Sleep Care",
            "image": "https://dentalsleepcare.in/logo.png",
            "url": "https://dentalsleepcare.in/contact",
            "telephone": "+917013686917",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Nihanya Luxour, Flat A-101, Opp. Aparna Heights II, Kondapur",
              "addressLocality": "Hyderabad",
              "postalCode": "500084",
              "addressCountry": "IN"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 17.4633646,
              "longitude": 78.3476649
            },
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                  "Monday",
                  "Tuesday"
                ],
                "opens": "10:00",
                "closes": "19:30"
              }
            ]
          })}
        </script>
      </Helmet>

      <PageHero
        title="Contact Us"
        subtitle="Have questions or ready to book?"
        subtitle2="Get in touch and schedule your appointment today."
        image={contact}
      />

      <section className="py-24 px-6 bg-white">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16">

          {/* Clinic Info */}
          <div>
            <h2 className="text-3xl font-bold text-secondary mb-8">Get in Touch</h2>
            <div className="space-y-8 mb-12">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMapPin} className="text-primary text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-secondary text-lg mb-1">Our Location</h4>
                  <p className="text-gray-600">Nihanya Luxour, Flat A-101,<br />
                    Opp. Aparna Heights II,<br />Kondapur, Hyd - 500 084.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="text-primary text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-secondary text-lg mb-1">Phone</h4>
                  <p className="text-gray-600">040-40055404, +917013686917</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMail} className="text-primary text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-secondary text-lg mb-1">Email</h4>
                  <p className="text-gray-600">childrendentistry12@gmail.com</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiClock} className="text-primary text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-secondary text-lg mb-1">Office Hours</h4>
                  <p className="text-gray-600">Thursday - Tuesday: 10:00am – 2:00pm <br /> 3:30pm - 7:30pm<br />Wednesday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gray-50 p-10 rounded-2xl shadow-soft">
            <h3 className="text-2xl font-bold text-secondary mb-6">Send us a Message</h3>
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* form unchanged */}
              ...
            </form>
          </div>
        </div>
      </section>

      {/* ✅ Map (Safe for react-snap) */}
      <section className="h-96 w-full bg-gray-200">
        {!isPrerender && (
          <iframe
            title="Clinic Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.923720394671!2d78.34766497516665!3d17.46336468343684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb90d330ef6045%3A0xd0a9f68b10b6487a!2sChildrens%20Dentistry!5e0!3m2!1sen!2sin!4v1774937738742!5m2!1sen!2sin"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        )}
      </section>

    </div>
  );
}
